module.exports = __webpack_public_path__ + "static/3-efdb1ed648beacc2b1ca9888a64d1b03.png";